import React, { useState } from "react";
import { AnimatePresence, motion, PanInfo } from "framer-motion";
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { tomos } from "../data/salesCopy";
import { SectionHeader } from "./SectionHeader";
export function Tomos() {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(1);
  const total = tomos.length;
  const tomo = tomos[index];
  const go = (next: number) => {
    setDir(next > index ? 1 : -1);
    setIndex((next + total) % total);
  };
  const onDragEnd = (_: unknown, info: PanInfo) => {
    if (info.offset.x < -50) go(index + 1);else if (info.offset.x > 50) go(index - 1);
  };
  return <section id="tomos" className="mx-auto max-w-5xl scroll-mt-4 px-5 py-9 md:py-16" data-id="element-304" data-mp="1w0mt7bd9mtuw">
      <SectionHeader eyebrow="CONTENIDO COMPLETO" title="LOS 6 TOMOS" subtitle="Tu hoja de ruta para resolver el ciclo lectivo 2027" data-id="element-305" data-mp="5nxnv73pnc8a" />

      <div role="tablist" aria-label="Tomos" className="no-scrollbar -mx-5 mt-5 flex gap-2 overflow-x-auto px-5 md:mx-0 md:mt-8 md:grid md:grid-cols-6 md:px-0" data-id="element-306" data-mp="1ndnzvrr5uig">
        {tomos.map((t, i) => {
        const isOn = i === index;
        return <button key={t.code} type="button" role="tab" aria-selected={isOn} onClick={() => go(i)} className={`flex shrink-0 items-center gap-2 rounded-xl px-3 py-2 text-left transition-colors duration-150 ease-out md:flex-col md:items-start md:gap-1 md:p-3 ${isOn ? "bg-chalk text-white" : "bg-card text-ink ring-1 ring-line hover:bg-chalk-soft"}`} data-id="element-307" data-mp="39ngikl229x1v" data-mpi={i}>
              <span className={`text-xs font-extrabold ${isOn ? "text-pencil" : "text-chalk"}`} data-id="element-308" data-mp="17wvk3rzhav9">{t.code}</span>
              <span className="whitespace-nowrap text-xs font-semibold md:whitespace-normal md:leading-snug" data-id="element-309" data-mp="66qbe2uqtdyl">{t.title.split(":")[0]}</span>
            </button>;
      })}
      </div>

      <div className="relative mt-3 overflow-hidden rounded-2xl bg-card ring-1 ring-line md:mt-4" data-id="element-310" data-mp="282jwp7hlm30l">
        <AnimatePresence mode="wait" initial={false} custom={dir} data-id="element-311" data-mp="201udp190nh6a">
          <motion.div key={tomo.code} role="tabpanel" custom={dir} initial={{
          opacity: 0,
          x: dir * 24
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: dir * -24
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.15} onDragEnd={onDragEnd} className="cursor-grab p-5 active:cursor-grabbing md:grid md:grid-cols-[1.2fr_1fr] md:gap-8 md:p-8" data-id="element-312" data-mp="1vzhgx2c8ytln">
            <div data-id="element-313" data-mp="2np2fh978k83k">
              <div className="flex items-center gap-3" data-id="element-314" data-mp="2nqnbz4d42142">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-chalk text-sm font-bold text-white md:h-12 md:w-12" data-id="element-315" data-mp="32md29epbx0el">{tomo.code}</span>
                <div data-id="element-316" data-mp="2xlf9672s6lyb">
                  <h3 className="font-display text-lg font-bold leading-tight md:text-2xl" data-id="element-317" data-mp="3h9bpsyl2fao1">{tomo.title}</h3>
                  <p className="text-sm font-semibold text-pencil-dark" data-id="element-318" data-mp="3lan62di1ujjk">{tomo.subtitle}</p>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-muted md:text-base" data-id="element-319" data-mp="37a2qdq7fl3ua">{tomo.description}</p>
            </div>
            <ul className="mt-4 space-y-2 rounded-xl bg-paper p-4 md:mt-0" data-id="element-320" data-mp="3c8nsjv68txld">
              {tomo.bullets.map(b => <li key={b} className="flex items-start gap-2 text-sm md:text-base" data-id="element-321" data-mp="2xj84imy3k69d">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-chalk" aria-hidden="true" data-id="element-322" data-mp="32dc9x1rps68c" />
                  <span data-id="element-323" data-mp="2omh7a77t6ld7">{b}</span>
                </li>)}
            </ul>
          </motion.div>
        </AnimatePresence>

        <div className="flex items-center justify-between border-t border-line px-5 py-3" data-id="element-324" data-mp="2emgp4oloebal">
          <button type="button" onClick={() => go(index - 1)} aria-label="Tomo anterior" className="rounded-full p-1.5 ring-1 ring-line transition-colors duration-150 ease-out hover:bg-paper" data-id="element-325" data-mp="2jljrg1a9u3ev">
            <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-326" data-mp="3mya0eq8pzf6h" />
          </button>
          <div className="flex gap-1.5" data-id="element-327" data-mp="3hzgvvnbeuyig">
            {tomos.map((t, i) => <span key={t.code} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? "w-5 bg-chalk" : "w-1.5 bg-line"}`} data-id="element-328" data-mp="3d52zbhl0ilc7" data-mpi={i} />)}
          </div>
          <button type="button" onClick={() => go(index + 1)} aria-label="Tomo siguiente" className="rounded-full p-1.5 ring-1 ring-line transition-colors duration-150 ease-out hover:bg-paper" data-id="element-329" data-mp="339svcob203vs">
            <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-330" data-mp="2u8bg185h0685" />
          </button>
        </div>
      </div>
      <p className="mt-2 text-center text-xs text-muted" data-id="element-331" data-mp="2pat89l36vx1q">Deslizá o tocá cada tomo para ver lo que incluye</p>
    </section>;
}